import script from "./cdw-given.vue?vue&type=script&lang=js&setup=true"
export * from "./cdw-given.vue?vue&type=script&lang=js&setup=true"

import "./cdw-given.vue?vue&type=style&index=0&id=bc4075e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bc4075e4"]])

export default __exports__